import { AsyncJobType } from '@recruitee/account/data';
import { bulkActionFactory } from '@recruitee/async-job/data';
import { createEntityCollectionStore } from '@recruitee/ngrx';

const idSelector = ({ uuid }: { uuid: string }) => uuid;
const { actions, namespace, reducer, selectors } = createEntityCollectionStore<{ uuid: string }>()(
  'locations-bulk-actions',
  {
    idSelector,
    customActions: adapter => {
      const getActions = bulkActionFactory(adapter);
      return {
        ...getActions('merge', AsyncJobType.BulkLocationsMerge)<{
          id: number;
          locationIds: number[];
        }>(),
      };
    },
  },
);

const LocationsBulkActions = {
  merge: actions.merge,
  mergeSuccess: actions.mergeSuccess,
  mergeFailed: actions.mergeFailed,
};

export {
  LocationsBulkActions,
  selectors as LocationsBulkSelectors,
  reducer as LocationsBulkReducer,
  namespace as LocationsBulkNamespace,
};
